import i18n from 'locales/i18n';

import { PlatformCode } from 'src/type/common';
import { IGAccountRes, IGReportRes } from '@apis/orval/model';

import { setFollowerRange } from '@utils/filterList';

import round from '@utils/round';

import { SimilarGroupProps } from './SimilarGroupIg';

export class SimilarGroupIgAdapter {
	value: IGReportRes;

	constructor(obj: IGReportRes) {
		this.value = obj;
	}

	get similarGroup() {
		return this.value?.account_recommendations?.similar_group_accounts ?? [];
	}

	columns = [
		i18n?.t(
			'infReportInstagram:features.report.section-content.ig.similar-group.item.follower',
		) ?? '',
		i18n?.t(
			'infReportInstagram:features.report.section-content.ig.similar-group.item.real-follower',
		) ?? '',
	] as [string, string];

	getCategoriesFromAccount(item: IGAccountRes): string[] {
		// const category1 = instagramCategories.get(item?.category_1)?.() ?? '';
		// const category2 = instagramCategories.get(item?.category_2)?.() ?? '';
		const category1 = item?.category_1 ?? '';
		const category2 = item?.category_2 ?? '';

		return [category1, category2].filter((v) => v) as string[];
	}

	getTablePropsItem(
		accountData: IGAccountRes,
	): SimilarGroupProps<['팔로워', '유효 팔로워']>['data'][number] {
		return {
			pk: accountData?.profile?.platform_pk ?? undefined,
			userName: accountData?.profile?.username ?? undefined,
			fullName: accountData?.profile?.full_name ?? undefined,
			profileImg: accountData?.profile?.profile_img_link ?? undefined,
			platformCode: (accountData?.profile?.platform_code as PlatformCode) ?? undefined,
			categories: this.getCategoriesFromAccount(accountData),
			[this.columns[0]]: i18n?.t('unit.number-of-person', {
				number: accountData?.profile?.follower
					? round(accountData?.profile?.follower, 'down')
					: '-',
			}),
			[this.columns[1]]: i18n?.t('unit.number-of-person', {
				number: accountData?.profile?.real_follower
					? round(accountData?.profile?.real_follower, 'down')
					: '-',
			}),
		};
	}

	get userName() {
		return this.value.account?.profile?.username ?? '-';
	}

	get category() {
		const category1 = this.value.account?.category_1 ?? '';
		const category2 = this.value.account?.category_2 ?? '';
		return ([category1, category2].filter((v) => v) as string[]).join(', ') ?? '-';
	}

	get followers() {
		return this.value.account?.profile?.follower
			? setFollowerRange(this.value.account?.profile?.follower)
			: '-';
	}

	adapt(): {
		props: SimilarGroupProps<['팔로워', '유효 팔로워']>;
		desc: {
			userName?: string;
			category?: string;
			followers?: string;
		};
	} {
		return {
			props: {
				header: this.columns as ['팔로워', '유효 팔로워'],
				data: this.similarGroup.map((accountData) => this.getTablePropsItem(accountData)),
			},
			desc: {
				userName: this.userName,
				category: this.category,
				followers: this.followers,
			},
		};
	}
}
